import {history} from "./history"

//once the Token has been expired this method is called
function Logout(){
    localStorage.clear();
    history.push("/LoginPage");
}

export default Logout;